import { graphql } from '@/utils/graphql';

export async function deleteAllSqlQueriesByDataset(
  datasetId: string,
  nextToken?: string,
): Promise<void> {
  const data = await graphql('sqlQueriesByDataset', { datasetId, nextToken }, true);
  await Promise.all(
    data.items.map(({ id, workspaceId }) => {
      if (!workspaceId) return null; // because old records don't have this field
      return graphql('deleteDatasetSqlQuery', { input: { id } });
    }),
  );
  if (data.nextToken) await deleteAllSqlQueriesByDataset(datasetId, data.nextToken);
}
